import React from 'react'
import styled from 'styled-components'
import { NudistaMedium14 } from '../Common/Fonts'
import SubdirLayout from './SubDirLayout'
import { Icon } from '../Common/CommonStyle'
import FolderView from './FolderView'
import { ColumnFlexDiv } from '../Common/CommonStyle'
const parentdirectories = [
  {
    name: 'Sub Folder',
    id: '1',
  },
]

const ParentdirectoryLayout = ({ thumbsviewNavbarMinified }) => {
  return (
    <ColumnFlexDiv width='100%'>
      {parentdirectories?.map((value) => (
        <RowFlexDiv
          width='100%'
          key={value.id}
          marginLeft='10px'
          justifyContent='flex-start'
        >
          <FolderView
            thumbsviewNavbarMinified={thumbsviewNavbarMinified}
            title={value.name}
            customWidth={value.customWidth}
          />
        </RowFlexDiv>
      ))}
    </ColumnFlexDiv>
  )
}

const RowFlexDiv = styled.div`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  opacity: ${({ opacity }) => opacity};
  z-index: ${({ zIndex }) => zIndex};
  overflow: ${({ overflow }) => overflow};
  outline: ${(props) => props.outline};
  position: ${(props) => props.position};
  top: ${(props) => props.top};
  text-overflow: ellipsis;
  white-space: nowrap;

  display: flex;
  flex-direction: row;
  justify-content: ${(props) => props.justifyContent || 'space-between'};
  align-items: center;
  gap: ${({ gap }) => gap};
  margin: ${({ margin }) => margin};
  margin-top: ${(props) => props.marginTop};
  margin-bottom: ${(props) => props.marginBottom};
  margin-left: ${(props) => props.marginLeft};
  background-color: ${(props) => props.backgroundColor};
  border-radius: ${(props) => props.borderRadius};
`

export default ParentdirectoryLayout
